<template lang="pug">
  include ResetPassword.pug
</template>

<script type="text/javascript">
import api from "@/service/api";

export default {
  name: "ResetPassword",
  props: ["recover_token"],
  data() {
    return {
      password: "",
      password2: "",
      finished: false,
    }
  },
  methods: {
    doReset: async function() {
      const response = await api.recoverPassword(this.password, this.recover_token)
      this.finished = true
    },
    goLogin() {
      this.$router.push({
        name: "Login",
      })
    }
  }
}
</script>
